import { Box, Flex } from "@chakra-ui/react"
import { PublishIcon, SyncIcon } from "./StatusIconButton"
import { usePublish } from "./StepPublishProvider"
import { stepPublishStatuses } from "./utils"

export const StepStatusButton = () => {
  const { publishStatus } = usePublish()

  const showSync = publishStatus === stepPublishStatuses.published

  return showSync ? <SyncIcon /> : <PublishIcon />
}

const StepPublishTrigger = () => {
  return (
    <Flex
      className="PathStepEditor__control__Publish"
      pos="relative"
      align="center"
    >
      <Box
        position="relative"
        display="inline-block"
        height="24px"
        width="1px"
        color="rgb(170, 170, 170)"
      >
        {" "}
        |{" "}
      </Box>
      <StepStatusButton />
    </Flex>
  )
}

export default StepPublishTrigger
